import Header from './Header';
import LearningHeader from './learning-header/LearningHeader';
import StudioHeader from './studio-header';
import messages from './i18n/index';

export { LearningHeader, messages, StudioHeader };

export default Header;
